import React from 'react';
import L, { divIcon } from 'leaflet';

export class OsmMarker extends React.Component {
  constructor(props) {
    super(props);
    this.entity = null;
    this.listeners = [];
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
  }

  componentDidMount() {
    const options = this.getOptions(this.props);
    this.setEntity(options);
    this.addListeners();
    if (this.props.infoWindowContent) {
      this.setInfoWindow();
      if (this.props.selected) {
        this.openInfoWindow();
      }
    }
  }

  componentWillUnmount() {
    this.removeListeners();
    this.removeEntity();
  }

  componentDidUpdate(prevProps) {
    if (this.props.icon !== prevProps.icon) {
      this.setIcon();
    }
    if (this.props.selected !== prevProps.selected) {
      this.props.selected ? this.openInfoWindow() : this.closeInfoWindow();
    }
  }

  addListeners() {
    this.entity.on('click', this.props.onClick)
    this.entity.on('mouseover', this.handleMouseOver)
    this.entity.on('mouseout', this.handleMouseOut)
  }

  removeListeners() {
    this.entity.off();
  }

  handleMouseOver() {
    this.openInfoWindow();
  }

  handleMouseOut() {
    !this.props.selected && this.closeInfoWindow();
  }

  openInfoWindow() {
    this.infowindow && this.infowindow.openPopup();
  }

  closeInfoWindow() {
    this.infowindow && this.infowindow.closePopup();
  }

  setEntity(options) {
    this.entity = L.marker([this.props.lat, this.props.lng], options);
    if (this.props.map) {
      this.entity.addTo(this.props.map);
    }
  }

  setInfoWindow() {
    this.infowindow = this.entity.bindPopup(this.props.infoWindowContent);
  }

  removeEntity() {
    this.entity.remove();
  }

  getOptions(props) {
    let options = {draggable: props.draggable};
    if (props.icon) {
      options.icon = this.getIcon(props.icon);
    }
    return options;
  }

  setIcon() {
    this.entity.setIcon(this.getIcon(this.props.icon));
  }

  getIcon(options) {
    if (options.html) {
      return L.divIcon({
        html: options.html,
        iconSize: [options.scaledSize.width, options.scaledSize.height],
        iconAnchor: [options.scaledSize.width / 2, options.scaledSize.height],
        popupAnchor: [0, -options.scaledSize.height]
      });
    }

    return L.icon({
      iconUrl: options.url,
      iconSize: [options.scaledSize.width, options.scaledSize.height],
      iconAnchor: [options.scaledSize.width / 2, options.scaledSize.height],
      popupAnchor: [0, -options.scaledSize.height]
    });
  }

  render() {
    return null;
  }
}
